/** Base URL de la API: vacío en prod (mismo origen), localhost:3001 en dev. */
export function getApiBaseUrl(): string {
  return process.env.REACT_APP_API_URL || '';
}
